<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import Notification from '$lib/notification/notification.svelte';
	export let showModal = false;
	export let withBlur = false;
	export let withoutCancel = false;
	export let classes = '';
	let dialog: HTMLDialogElement | null = null; // HTMLDialogElement

	const dispatch = createEventDispatcher();

	$: if (dialog && showModal) dialog.showModal();
	$: if (dialog && !showModal) dialog.close();

	function closeModal() {
		if (withoutCancel) return;
		dialog?.close();
		showModal = false;
		dispatch('close-modal');
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions -->
<dialog
	bind:this={dialog}
	on:close={closeModal}
	class={` relative m-0 h-full min-h-[100vh] w-full min-w-[100vw] ${classes}`}
	class:is-blur={withBlur}
>
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<slot />
	{#if !withoutCancel}
		<button
			translate="no"
			class="material-icons-round absolute right-8 top-8 text-2xl text-grey-700 hover:text-grey-900"
			on:click={closeModal}>close</button
		>
	{/if}
	<Notification />
</dialog>

<style>
	dialog {
		overflow: inherit;
	}
	dialog::backdrop {
		background: rgba(0, 0, 0, 0.3);
	}

	dialog.is-blur::backdrop {
		backdrop-filter: blur(4px);
	}

	dialog:focus-visible {
		outline: none;
	}

	dialog[open] {
		animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
	}
	@keyframes zoom {
		from {
			transform: scale(0.95);
		}
		to {
			transform: scale(1);
		}
	}
	dialog[open]::backdrop {
		animation: fade 0.2s ease-out;
	}
	@keyframes fade {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
</style>
